module.exports = __webpack_public_path__ + "img/rect.b33ed450.gif";